/* eslint-disable no-nested-ternary */
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { useSpring, animated } from "@react-spring/web";

// Components
import GoTop from "components/atoms/GoTop";

// Containers
import HeaderContainer from "containers/organisms/HeaderContainer";
import SidebarContainer from "containers/organisms/SidebarContainer";

// Utils

// Hooks
import { useLoaderStore } from "stores/loader";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useSettingsStore } from "stores/settings";

import TabBarContainer from "../../../containers/molecules/TabBarContainer";
import Footer from "../../organisms/Footer";

// Selectors
import * as authSelectors from "../../../redux/auth/selectors";

import "./styles.sass";

const FortuneWheelLayout = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const isSidebarOpen = useSettingsStore((state) => state.isSidebarOpen);
  const { isCustomBreakpointSmaller } = useBreakpoint(1370);
  const { width, gridTemplateColumns } = useSpring({
    width: isCustomBreakpointSmaller ? 76 : isSidebarOpen ? 256 : 76,
    gridTemplateColumns: isCustomBreakpointSmaller
      ? "76px 1fr"
      : isSidebarOpen
        ? "256px 1fr"
        : "76px 1fr",
    transform: `rotate(${isSidebarOpen ? 0 : 180}deg)`,
  });
  const { overlayLoading } = useLoaderStore();

  const ContainerClass = classNames("FortuneWheelLayout__container", {
    loading: overlayLoading,
    auth: isAuthenticated,
  });

  const HeaderClass = classNames("FortuneWheelLayout__header", {
    // eslint-disable-next-line camelcase
    CasinoLayout__header_auth: isAuthenticated,
  });

  const LayoutClass = classNames("FortuneWheelLayout__content_container", {
    // eslint-disable-next-line camelcase
  });
  const LayoutClassForMargin = classNames("FortuneWheelLayout__content", {
    // eslint-disable-next-line camelcase
  });

  return (
    <div className="FortuneWheelLayout">
      <animated.div className={ContainerClass} style={{ gridTemplateColumns }}>
        <animated.div className={HeaderClass} style={{ gridTemplateColumns }}>
          <animated.div
            className="FortuneWheelLayout__header_empty"
            style={{ width }}
          />
          <HeaderContainer />
        </animated.div>

        <animated.div className="FortuneWheelLayout__sidebar" style={{ width }}>
          <SidebarContainer />
        </animated.div>

        <div className={LayoutClassForMargin}>
          <div className={LayoutClass}>
            <Outlet />
          </div>
          <GoTop />
        </div>
        <TabBarContainer />
        <div className="FortuneWheelLayout__footer">
          <Footer />
        </div>
      </animated.div>
    </div>
  );
};

export default FortuneWheelLayout;
